import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { languages } from "../App";
import { TfiLocationPin} from "react-icons/tfi"
const Locations = () => {
      const { t } = useTranslation();
      const currentLangCode = cookies.get("i18next") || "en";
      const currentLang = languages.find((l) => l.code === currentLangCode);

      const [locationIn ,setLocationIn] = useState(true)
  return (
    <div id="loc" className="tw-bg-gray-50">
    <div className=" tw-w-[85%] tw-mx-auto tw-py-16">
        <div className="tw-flex tw-items-center" data-aos="zoom-in" >
        <span className="tw-h-[2px] tw-bg-one-gold tw-w-[40px] "></span>
            <span className=" tw-capitalize tw-text-3xl tw-font-bold tw-text-one-gold tw-p-5 sm:tw-p-3 tw-whitespace-nowrap sm:tw-text-2xl">{t("link3")}</span>
        </div>
        <div className=" tw-flex tw-items-center tw-gap-1 tw-p-3 tw-m-3" data-aos="zoom-in" data-aos-duration="2000">
            <div className={`tw-flex tw-items-center tw-gap-2  tw-border-b tw-border-b-one-gold tw-cursor-pointer tw-p-4 md:tw-p-2 tw-px-7 md:tw-px-5 tw-w-[200px] hover:tw-bg-third-gold tw-font-semibold  tw-rounded-md hover:tw-text-white md:tw-w-full xs:tw-text-sm tw-whitespace-nowrap tw-transition-all tw-duration-500 tw-ease-in-out
            ${locationIn ? "tw-bg-third-gold tw-text-white" : "tw-text-gray-400"}`}
            onClick={() => setLocationIn(true)} >
                <span><TfiLocationPin /></span>
                <span>{t("locationIn")}</span>
            </div>
            <div className={`tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-b-one-gold tw-cursor-pointer tw-p-4 md:tw-p-2 tw-px-7 md:tw-px-5 tw-w-[200px] hover:tw-bg-third-gold tw-font-semibold  tw-rounded-md hover:tw-text-white md:tw-w-full xs:tw-text-sm tw-whitespace-nowrap tw-transition-all tw-duration-500 tw-ease-in-out
            ${!locationIn ? "tw-bg-third-gold tw-text-white" : "tw-text-gray-400"}`}
            onClick={() => setLocationIn(false)} >
                <span><TfiLocationPin /></span>
                <span>{t("locationOut")}</span>
            </div>
        </div>
         
         <div  className="tw-p-3 tw-m-3" data-aos="zoom-in" data-aos-duration="2000">
            <p className={` tw-border-third-gold tw-p-2 ${currentLangCode === "en" ? "tw-border-l-4 tw-pl-4" : "tw-border-r-4 tw-pr-4"} tw-text-gray-500 tw-text-lg md:tw-text-sm xs:tw-text-xs`}>
                {
                    locationIn ? 
                    t("discrip_loc_in")
                    :
                    t("discrip_loc_out")
                }
            </p>
         </div>
    <div className=" tw-w-full" data-aos="zoom-in" data-aos-duration="2000">
        {
            locationIn ?
            <iframe
            className=" tw-w-full tw-rounded-lg tw-shadow-md "
              width="600"
              height="500"
              id="gmap_canvas"
              src="https://maps.google.com/maps?q=%20SUDAN%20%E2%80%93%20KHARTOUM%20%E2%80%93%20ARABY%20MARKET%20%E2%80%93%20GOLD%20BUILDING&t=&z=13&ie=UTF8&iwloc=&output=embed"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
            ></iframe>

          :
        <iframe
        className=" tw-w-full tw-rounded-lg tw-shadow-md "
          width="600"
          height="500"
          id="gmap_canvas"
          src="https://maps.google.com/maps?q=%20United%20Arab%20Emirates%20%E2%80%93%20Dubai%20%E2%80%93%20Deira%20%E2%80%93%20Al%20soor%20Street%20%E2%80%93%20Shams%20Al%20daghaya%20Building&t=&z=13&ie=UTF8&iwloc=&output=embed"
          frameBorder="0"
          scrolling="no"
          marginHeight="0"
          marginWidth="0"
        ></iframe>
        }
      
     
      </div>
    </div>
    </div>
  );
};

export default Locations;
